export default __webpack_public_path__ + "static/media/pipe_leak.svg";